








import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ui-toolbar"
})
export default class UiToolbarComponent extends Vue {
  @Prop({ default: "light", type: String })
  theme: string;

  @Prop({ default: false, type: Boolean })
  wide: boolean;
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-toolbar/src/ui-toolbar.vue